module.exports = __webpack_public_path__ + "static/media/fondo-home-paquetes.bddff67e.jpg";